import CheckCircle from "@mui/icons-material/CheckCircle";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

export const AuthAlerts = ({ alertOpen, setAlertOpen, alertSeverity, alertMessage }: { alertOpen: boolean, setAlertOpen: React.Dispatch<React.SetStateAction<boolean>>, alertSeverity: "error" | "info" | "success", alertMessage: string },) => {

    const hideAlert = () => {
        setAlertOpen(false);
    };

    return (
        alertOpen && alertMessage && (
            <Snackbar
                open={alertOpen}
                autoHideDuration={5000}
                onClose={hideAlert}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                sx={{
                    zIndex: 99999,
                    position: 'fixed',
                    top: '20px !important'
                }}
            >
                <Alert
                    onClose={hideAlert}
                    severity={alertSeverity}
                    sx={{
                        width: "100%",
                        minWidth: "400px",
                        fontSize: "1rem",
                        fontWeight: 500,
                        boxShadow: 2
                    }}
                    icon={alertSeverity === "success" ? <CheckCircle /> : undefined}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        )
    );
};